import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { PadlockService } from "../../padlock/padlock.service";
import { SideNavState } from "../../side-nav/state/side-nav/side-nav.reducer";
import { selectSideNavState } from "../../side-nav/state/side-nav/side-nav.selectors";
import { UserRoutes } from "../user-routing.module";

@Component({
  selector: "app-user-nav",
  templateUrl: "./user-nav.component.html",
  styleUrls: ["./user-nav.component.scss"],
  standalone: false,
})
export class UserNavComponent implements OnInit {
  USER_ROUTES = UserRoutes;
  isPlatformAdmin = false;

  sideNav$: Observable<SideNavState> = this.store.select(selectSideNavState);

  constructor(
    public store: Store<any>,
    private padlockService: PadlockService,
  ) {}

  ngOnInit() {
    const decoded = this.padlockService.getDecodedToken();
    this.isPlatformAdmin = decoded?.platform_admin === true;
  }
}
